import router from './router'
import useUserStore from './store'
import UserMessages from './localization'

export default {
  router,
  useUserStore,
  localization: UserMessages,
}
